import { largeCurrencyFormat } from 'common/formats/formats';
import {
  DISTRIBUTION_TITLE_CELL_KEY,
  DISTRIBUTION_TITLE_LABEL,
  PER_SHARE_TITLE_CELL_KEY,
  PER_SHARE_TITLE_LABEL,
} from 'dashboard409a/common/constants/components/waterfallTable';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import { TABLE_TITLE } from './rowConfig';
import { Cell, Config, ParseCellProps } from './types';

const parseCell = ({ row, key, columnLegend, value, additionalProps = {} }: ParseCellProps): Cell => ({
  ...row,
  key,
  rowSpan: 1,
  columnLegend,
  value,
  ...additionalProps,
});

const parser = async ({ columns, rowConfig }: Config): Promise<Record<string, Cell>> => {
  const cells: Record<string, Cell> = {};
  const alphabet = alphabetGenerator([], columns.length);

  rowConfig.forEach((row, rowIdx) => {
    const rowNumber = rowIdx + 1;

    columns.forEach((col, colIdx) => {
      const columnLegend = alphabet[colIdx];
      const key = `${columnLegend}${rowNumber}`;
      const lastRowNumber = rowConfig.length;
      const PER_SHARE_TOTALS_CELL_KEY = `B${lastRowNumber}`;
      const DISTRIBUTION_COLUMN_LABEL = 'A';

      let value = col[row.alias];
      let additionalProps = {};

      if (rowNumber === 1 || row.alias === TABLE_TITLE) {
        // Add labels to the first row
        if (key === DISTRIBUTION_TITLE_CELL_KEY) {
          value = DISTRIBUTION_TITLE_LABEL;
        } else if (key === PER_SHARE_TITLE_CELL_KEY) {
          value = PER_SHARE_TITLE_LABEL;
        }
        // Clear the total of per share column
      } else if (key === PER_SHARE_TOTALS_CELL_KEY) {
        value = '';
        additionalProps = { expr: '', format: '' };
      } else if (rowNumber > 1 && row.alias !== TABLE_TITLE) {
        if (columnLegend === DISTRIBUTION_COLUMN_LABEL) {
          additionalProps = { ...additionalProps, format: largeCurrencyFormat };
        }
      }

      cells[key] = parseCell({ row, key, columnLegend, value, additionalProps });
    });
  });

  return cells;
};

export default parser;
